// extracted by mini-css-extract-plugin
export default {"data-row":"a9c0fe"};